import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { bbbeeModule } from "../../../Component/Common/Constants/routes";
import { useRouteMatch } from "../../../Helpers/RouteMatcher";
import { BBBEEScorecardAtom } from "../../../State/BBBEEScorecard.Atom";
import { Planner } from "./Planner/Planner";
import { Elements } from "./Elements/Elements";
import { Reminders } from "./Reminders/Reminders";
import { isNullOrEmpty } from "../../../Component/Model/helpers";


export const VerificationProcessBase = () => {

    const scorecard = useRecoilValue(BBBEEScorecardAtom);

    const routes = [
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.plannerAndTracker}`,
        `/bee/scorecard/${scorecard.scorecardId}/${bbbeeModule.verificationProcess}/${bbbeeModule.elements}`,
    ]

    const location = useLocation();
    const routeMatch = useRouteMatch(routes);

    let currentTab = routeMatch?.path;
    if (currentTab == null) {
        if (location.pathname.includes(routes[0])) {
            currentTab = routes[0];

        }
        else if (location.pathname.includes(routes[1])) {
            currentTab = routes[1];
        }
    }

    if (isNullOrEmpty(scorecard.scorecardId)){
        return null;
    }
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Planner & Tracker" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Elements" value={routes[1]} to={routes[1]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        <Route path={routes[0]}>
                            <Planner />
                        </Route>
                        <Route path={routes[1]}>
                            <Elements scorecardId={scorecard.scorecardId} />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
            <Reminders scorecardId={scorecard.scorecardId} />
        </>);
}